<template>
  <div :id="id" class="row align-items-center">
    <LmTextInput
      ref="inputFocus"
      :id="`label-${id}`"
      class="col-12 col-md-6"
      v-model="component.componentProps.label"
      @input="onLabelChange($event)"
      :label="$t('title')"
      :placeholder="$t('title')"
      :help="$t('comp_title_help')"
    />
    <LmTextInput
      v-if="validateSuperUser"
      :id="`name-${id}`"
      class="col-12 col-md-6"
      v-model="component.formObjectToSendToServerProperty"
      @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
      :label="$t('name')"
      :placeholder="$t('name')"
      :help="$t('comp_name_help')"
    />
    <LmSelect
      :id="`css-${id}`"
      class="col-12 col-md-6"
      v-model="component.class"
      :options="{
        content: [
          {value: 'col-12 col-md-12', text: '100%'}
        ]
      }"
      :label="$t('desktop_view_width')"
      :help="$t('help_width_form_element')"
      @input="$emit('input', component)"
    />
    <LmTextInput
      :id="`help-${id}`"
      class="col-12 col-md-6"
      v-model="component.componentProps.help"
      @input="$emit('input', component)"
      :label="$t('helper_text_setter')"
      :placeholder="$t('helper_text_setter')"
      :help="$t('helper_text_setter_help')"
    />
    <small class="col-12 mb-2">Puede definir variables dentro de %nombre de variable%. Tambien es posible vincular otros campos del formulario escribiendo el título del campo como nombre de variable.</small>
    <LmEditor
      class="col-12"
      :value="component.componentProps.defaultValue.html"
      :label="$t('default_value')"
      @input="onDefaultValueChange"
    />
    <hr class="w-100 mx-2">
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      :self="component.formObjectToSendToServerProperty"
    />
  </div>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSelect from '@/components/form/elements/LmSelect'
import LmEditor from '@/components/form/elements/lmEditor'
import LmNumberInputV2 from '@/components/form/elements/LmNumberInputV2'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'

import { nanoid } from 'nanoid'

export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {}
  },
  components: {
    LmButton,
    LmCheckbox,
    LmSelect,
    LmEditor,
    LmNumberInputV2
  },
  methods: {
    addOption () {
      this.component.componentProps.variablesOptions.push({ id: nanoid(5), name: '', value: '' })
    },
    removeOption (optionIndex) {
      this.component.componentProps.variablesOptions.splice(optionIndex, 1)
    },
    onDefaultValueChange (event) {
      this.component.componentProps.defaultValue.html = event
      this.component.componentProps.defaultValue.vars = {}
      this.$emit('input', this.component)
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
